import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import Routes from './routes';
import { ConfigProvider } from 'antd';
import fa_IR from 'antd/lib/locale-provider/fa_IR';
import 'antd/dist/antd.css';
import './assets/styles/app.css';

import {
    ApolloClient,
    InMemoryCache,
    ApolloProvider,
} from "@apollo/client";

function findToken(){
    return localStorage.getItem('user') ? 'Bearer ' + JSON.parse(localStorage.getItem('user')).jwt.toString() : '';
}

console.log('find tokrn' , findToken());

const client = new ApolloClient({
    uri: 'https://admin.bayatiexchange.com/graphql',
    cache: new InMemoryCache(),
    headers : {
        authorization : findToken()
    }
});

ReactDOM.render(

<ConfigProvider locale={fa_IR}>
    <ApolloProvider client={client}>
        <Routes />
    </ApolloProvider>
</ConfigProvider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
